import { render, staticRenderFns } from "./appletPopup.vue?vue&type=template&id=208b4745&scoped=true&"
import script from "./appletPopup.vue?vue&type=script&lang=js&"
export * from "./appletPopup.vue?vue&type=script&lang=js&"
import style0 from "./appletPopup.vue?vue&type=style&index=0&id=208b4745&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208b4745",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('208b4745')) {
      api.createRecord('208b4745', component.options)
    } else {
      api.reload('208b4745', component.options)
    }
    module.hot.accept("./appletPopup.vue?vue&type=template&id=208b4745&scoped=true&", function () {
      api.rerender('208b4745', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/SOP/components/appletPopup.vue"
export default component.exports